// Generated by BUCKLESCRIPT, PLEASE EDIT WITH CARE
'use strict';

var React = require("react");
var Dialog = require("@reach/dialog");

function Dialog$1(Props) {
  var isOpenOpt = Props.isOpen;
  var allowPinchZoomOpt = Props.allowPinchZoom;
  var onDismiss = Props.onDismiss;
  var classNameOpt = Props.className;
  var ariaLabel = Props.ariaLabel;
  var children = Props.children;
  var isOpen = isOpenOpt !== undefined ? isOpenOpt : true;
  var allowPinchZoom = allowPinchZoomOpt !== undefined ? allowPinchZoomOpt : true;
  var className = classNameOpt !== undefined ? classNameOpt : "";
  return React.createElement(Dialog.Dialog, {
              isOpen: isOpen,
              onDismiss: onDismiss,
              allowPinchZoom: allowPinchZoom,
              "aria-label": ariaLabel,
              className: className,
              children: children
            });
}

var make = Dialog$1;

exports.make = make;
/* react Not a pure module */
